import Vue from 'vue';

let general_data = JSON.parse(localStorage.getItem('sts-data') || '{}') || {}

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        profession_types: general_data.profession_types || [],
        psychological_complaints: [],
        medical_complaints: [],
        person_types: general_data.person_types || [],
        consumption_types: general_data.consumption_types || [],
        sleep_types: general_data.sleep_types || [],
        medication_types: general_data.medication_types || [],
        know_us_sources: general_data.know_us_sources || [],
    },
    // -----------------------------------------------------------------
    getters: {
        professionTypes: (state) => { return state.profession_types },
        psychologicalComplaints: (state) => { return state.psychological_complaints },
        medicalComplaints: (state) => { return state.medical_complaints },
        personTypes: (state) => { return state.person_types },
        consumptionTypes: (state) => { return state.consumption_types },
        sleepTypes: (state) => { return state.sleep_types },
        medicationTypes: (state) => { return state.medication_types },
        knowUsSources: (state) => { return state.know_us_sources },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_PROFESSION_TYPES(state, types) {
            general_data.profession_types = types
            state.profession_types = types
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
        SET_PSYCHOLOGICAL_COMPLAINTS(state, compaints) {
            state.psychological_complaints = compaints
        },
        DELETE_PSYCHOLOGICAL_COMPLAINT(state, id) {
            const psychological_complaint_ids_index = state.psychological_complaints.findIndex((t) => t.id === id);
            if (psychological_complaint_ids_index > -1) state.psychological_complaints.splice(psychological_complaint_ids_index, 1);
        },
        SET_MEDICAL_COMPLAINTS(state, compaints) {
            state.medical_complaints = compaints
        },
        DELETE_MEDICAL_COMPLAINT(state, id) {
            const medical_complaint_ids_index = state.medical_complaints.findIndex((t) => t.id === id);
            if (medical_complaint_ids_index > -1) state.medical_complaints.splice(medical_complaint_ids_index, 1);
        },
        SET_PERSON_TYPES(state, types) {
            general_data.person_types = types
            state.person_types = types
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
        SET_CONSUMPTION_TYPES(state, types) {
            general_data.consumption_types = types
            state.consumption_types = types
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
        SET_SLEEP_TYPES(state, types) {
            general_data.sleep_types = types
            state.sleep_types = types
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
        SET_MEDICATION_TYPES(state, types) {
            general_data.medication_types = types
            state.medication_types = types
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
        SET_KNOW_US_SOURCES(state, sources) {
            general_data.know_us_sources = sources
            state.know_us_sources = sources
            localStorage.setItem('sts-data', JSON.stringify(general_data));
        },
    },
    // -----------------------------------------------------------------
    actions: {
        professionTypes: context => {
            if (context.getters.professionTypes.length !== 0) return

            return Vue.api.get('profession-types')
                .then(response => {
                    context.commit('SET_PROFESSION_TYPES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        psychologicalComplaints: (context, user_id) => {
            return Vue.api.get(`users/${user_id}/psychological-complaints`)
                .then(response => {
                    context.commit('SET_PSYCHOLOGICAL_COMPLAINTS', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        deletePsychologicalComplaint: (context, id) => {
            context.commit('DELETE_PSYCHOLOGICAL_COMPLAINT', id)
        },
        medicalComplaints: (context, user_id) => {
            return Vue.api.get(`users/${user_id}/medical-complaints`)
                .then(response => {
                    context.commit('SET_MEDICAL_COMPLAINTS', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        deleteMedicalComplaint: (context, id) => {
            context.commit('DELETE_MEDICAL_COMPLAINT', id)
        },
        personTypes: context => {
            if (context.getters.personTypes.length !== 0) return

            return Vue.api.get('person-types')
                .then(response => {
                    context.commit('SET_PERSON_TYPES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        consumptionTypes: context => {
            if (context.getters.consumptionTypes.length !== 0) return

            return Vue.api.get('consumption-types')
                .then(response => {
                    context.commit('SET_CONSUMPTION_TYPES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        sleepTypes: context => {
            if (context.getters.sleepTypes.length !== 0) return

            return Vue.api.get('sleep-types')
                .then(response => {
                    context.commit('SET_SLEEP_TYPES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        medicationTypes: context => {
            if (context.getters.medicationTypes.length !== 0) return

            return Vue.api.get('medication-types')
                .then(response => {
                    context.commit('SET_MEDICATION_TYPES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        knowUsSources: context => {
            if (context.getters.knowUsSources.length !== 0) return

            return Vue.api.get('know-us-sources')
                .then(response => {
                    context.commit('SET_KNOW_US_SOURCES', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}